let adjust_data_tables = (id) => {
    window.Smart.utils.debounce(function () {
        window.DataTables = window.DataTables || {};

        let keys = Object.keys(window.DataTables);

        for (let i = 0; i < keys.length; i++) {
            let key = keys[i];
            let dataTable = window.DataTables[key]

            try {
                dataTable.columns.adjust()
            } catch (e) {}
        }
    }, 250);
}

export default adjust_data_tables;
